import React from 'react';
import { Container, Jumbotron, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const VerifySuccess = () => {
  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Jumbotron
        style={{
          maxWidth: '600px',
          width: '100%',
          textAlign: 'center',
          marginTop: '2rem',
        }}
      >
        <h1 className="mb-3">✅ Email Verified</h1>
        <p className="mb-4">
          Your email has been successfully verified. You can now log in to your MyLifeClock account.
        </p>

        <LinkContainer to="/login">
          <Button variant="primary">
            Go to Login
          </Button>
        </LinkContainer>
      </Jumbotron>
    </Container>
  );
};

export default VerifySuccess;